"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_ICON_DATA_HOOK = exports.CHAR_COUNTER_DATA_HOOK = exports.LABEL_DATA_HOOK = exports.TEXT_AREA_ERROR_DATA_HOOK = exports.TEXT_AREA_DATA_HOOK = void 0;
exports.TEXT_AREA_DATA_HOOK = 'text-area';
exports.TEXT_AREA_ERROR_DATA_HOOK = 'text-area-error-icon';
exports.LABEL_DATA_HOOK = 'text-area-label';
exports.CHAR_COUNTER_DATA_HOOK = 'char-counter';
exports.ERROR_ICON_DATA_HOOK = 'error-Icon';
//# sourceMappingURL=dataHooks.js.map